import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterKeyValue',
    standalone: false
})
export class FilterKeyValuePipe implements PipeTransform {

  transform(localArray: { [key: string]: any }[], key: string, value: any): { [key: string]: any }[] {
    if (localArray == undefined || key == undefined || value == undefined) {
      return localArray;
    }
    return localArray.filter(item => item[key] === value);
  }

}
